import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  gap: 6px;
  @media (max-width: 576px) {
    min-width: 200px;
    width: 200px;
  }
  .data {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
    flex: 1;
  }

  p {
    margin: 0;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 30%;
  aspect-ratio: 1/1;
  flex-shrink: 0;
`;

export const Mask = styled.div`
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    text-transform: uppercase;
    text-decoration: underline;
    color: white;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  border: 1px solid #e9ecef;
  ${({ $isPlaceholder }) => ($isPlaceholder ? 'opacity: 0.3;' : '')};
`;
